import React from 'react'
import Topbar from './common/Topbar'
import { useLocation } from 'react-router-dom'
export default function Howto() {
  return (
    
    <div>
      <Topbar option={"howto"}/>
      <div className='main flex flex-center'>
        <div className='how '>
            <h2>How to</h2>
            <h4>SELECT ANIMATION CATEGORY:</h4>
            <p>Get started by choosing your required animation from the navigation menu present at the top of the screen.</p>
            <div className='htimage ' id='htimg'></div>
            <p>The animaion category consists of the following feilds:</p>
            <ol>
                <li>
                    <h5>Primary</h5>
                    <p>This menu contains all the primary effects that are most commonly used in a web application. You can get the basic effects on the test DIV like zoomin,zoomout,slide,rotate and flip </p>
                </li>
                <li>
                    <h5>Appearance </h5>
                    <p>It consists of  entry animation that is very useful for making landing pages,sliders,etc.</p>
                </li>
                <li>
                    <h5>Exit</h5>
                    <p>It consists of exiting or closing effects which are helpful for making closing window,app effects.</p>
                </li>
                <li>
                    <h5>Focus</h5>
                    <p>It have some really awesome special effects </p>
                </li>
            </ol>
            <h4>SELECT YOUR ANIMATION:</h4>
            <p>After select your preferable animation category. Choose the animation type from the left navigation menu.
Now choose the variant of your required animation from the pop up menu.
You can see the change in animation property of the test div.
</p>
            <h4>CSS PROPERTIES MODIFICATION</h4>
            <h5>BASIC PROPERTIES</h5>
            <div className='htimage ' id='htimg2'></div>
            <p>You can modify the basic CSS animation properties like duration, delay, iteration, direction, fill mode by the table, provided on the top left corner of the application. After modifying the fields, press the apply button to apply the changes on the test div. In order to reset the values to default, use the reset button.</p>
            <h4>TEST DIV SHAPE</h4>
            <p>You can modify the shape of the test DIV by using the shape navigation menu.</p>
            <h4>FLOW MODIFICATION</h4>
            <p>The flow of the animation can also be modified by using the BEIZER EDITOR. The common flow properties like ease,linear,easein,easeout,easeinout can be directly applied by Selecting the particular curves. You can also provide your own flow by modifying the Biezer curve as for your requirement by pressing the configure button. After configuring press the apply button to apply the changes on the test DIV. </p>
            <div className='htimage ' id='htimg4'></div>
            <h4>THE CODE MENU</h4>
            <p>You can copy your modified code directly to your clipboard from the code menu. The code menu is accessed by the code button. The code menu consist of the CSS code, which defines the shape of the test DIV Along with your customized keyframes. You can directly import the code segment from the code menu.</p>
        </div>
      </div>
    </div>
  )
}
